import usePreview from "../../contexts/usePreview.js";
import { useTranslation } from "react-i18next";

const MultiStepModal = ({ onClose, activeDate, previousDate }) => {
  const { handlePreview, loading } = usePreview();
  // Retrieve fieldName from local storage
  const localData = JSON.parse(localStorage.getItem("report")) || {};
  const fieldName = localData.fieldName || "Unnamed Field";
  const { t, i18n } = useTranslation();
  const previewReport = () => {
    handlePreview(fieldName, activeDate, previousDate);
  };

  return (
    <>
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 overflow-y-auto overflow-x-hidden">
        <div className="bg-white w-full max-w-4xl p-8 rounded-xl shadow-2xl relative transition duration-300 ease-out transform hover:scale-105">
          <button
            className="absolute top-3 right-5 w-7 h-7 text-gray-700 hover:text-white bg-gray-200 hover:bg-red-600 rounded-full p-0 cursor-pointer transition duration-300"
            onClick={() => onClose(false)}
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {/* Title with Logo */}
          <div className="flex items-center justify-between space-x-4 mb-6">
            <div className="flex gap-2 items-center">
              <img
                src={require("../../assets/crops.jpg")} // Replace with Crop2x logo URL
                alt="Crop2x Logo"
                className="w-12 h-12 rounded-full"
              />
              <h2 className="text-2xl font-bold">{fieldName.split('-')[0]}</h2>
            </div>
            <h3 className="text-lg font-semibold  text-gray-400">
              {activeDate}
            </h3>
          </div>

          {/* Buttons */}
          <div className="mt-8 flex justify-center space-x-4">
            <button
              onClick={previewReport}
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300"
            >
              {loading ? <div className="flex justify-center" >
                <div className="text-white text-xl animate-pulse">
                  {i18n.language === "ur" ? "لوڈ ہو رہا ہے" : "Loading"}
                </div>

                <div className="loading loading-spinner text-success"></div>
              </div>
                :
                (i18n.language === "ur" ? "پیش نظارہ" : "Preview")}

            </button>
            {/* {loading && (
        <div className="loader mt-4 text-blue-500 text-sm">
          Fetching data...
        </div>
      )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiStepModal;